import * as React from 'react';
import { FilterLineForSurveyMonkeyFilter } from 'flow-doctor-lib/utils/filterRenderUtils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import WalmartAbstractFilterRenderer from 'flow-doctor-lib/components/filters/WalmartAbstractFilterRenderer';
import { jsx as _jsx } from "react/jsx-runtime";
const WalmartSurveyMonkeyFilterRenderer = ({
  filter
}) => {
  return /*#__PURE__*/_jsx(WalmartAbstractFilterRenderer, {
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: filter.filterType === 'SURVEY_MONKEY' ? 'flow-doctor-lib.filters.surveyMonkey.surveyLabel' : 'flow-doctor-lib.filters.surveyMonkey.questionLabel'
    }),
    filterLine: /*#__PURE__*/_jsx(FilterLineForSurveyMonkeyFilter, {
      filter: filter
    })
  });
};
export default WalmartSurveyMonkeyFilterRenderer;